import { combineReducers } from 'redux';

import apiError from 'middleware/apiError.reducer';
import auth from 'modules/auth/auth.reducer';
import authorizations from 'modules/authorizations/store/reducers/authorizationRoot.reducer';
import benefit from 'modules/benefit/benefit.reducer';
import clients from 'modules/clients/clients.reducer';
import common from 'modules/common/common.reducer';
import dashboard from 'modules/dashboard/dashboard.reducer';
import eaDashboard from 'modules/eaDashboard/eaDashboard.reducer';
import expenseManagerDashboard from 'modules/expenseManagerDashboard/expenseManagerDashboard.reducer';
import myFiles from 'modules/dashboard/myFiles/myFiles.reducer';
import opsManagerDashboard from 'modules/opsManagerDashboard/opsManagerDashboard.reducer';
import expenses from 'modules/expenses/store/expenses.reducer';
import intake from 'modules/intake/intake.reducer';
import layout from 'modules/layout/layout.reducer';
import selfService from 'modules/selfService/selfService.reducer';
import surveys from 'modules/surveys/surveys.reducer';
import taskRules from 'modules/taskRules/taskRules.reducer';
import enumerations from 'modules/enumerations/store/enumeration.reducer';
import templates from 'modules/emailTemplates/store/emailTemplate.reducer';
import fees from 'modules/fees/fees.reducer';
import acumaticaLogs from 'modules/acumaticaLogs/store/acumaticaLogs.reducer';

const rootReducer = combineReducers({
  auth,
  authorizations,
  intake,
  common,
  layout,
  benefit,
  selfService,
  apiError,
  clients,
  dashboard,
  eaDashboard,
  expenseManagerDashboard,
  myFiles,
  opsManagerDashboard,
  expenses,
  surveys,
  taskRules,
  enumerations,
  templates,
  fees,
  acumaticaLogs
});

export default rootReducer;
